import React, { useEffect, useMemo } from 'react';
import { CoverBackground } from '../../../components/CoverBackground/coverBackground';
import { Box } from '@chakra-ui/react';
import { containerMaxWXl } from '../../../components/ContentContainer/contentContainer';
import { UserHeader } from '../UserHeader/userHeader';
import { ethers } from 'ethers';
import { Editor } from '../Editor/editor';
import { emptyUserEditorFields, useUserEditorProvider } from '../../../providers/UserEditor/userEditorProvider';
import { useBlockchainProvider } from '../../../providers/Blockchain/blockchainProvider';
import { useUserProvider } from '../../../providers/User/userProvider';

interface IHeader {
	dataHandle: string;
}

export const Header = ({ dataHandle }: IHeader) => {
	const { account } = useBlockchainProvider();
	const { isLoading, data } = useUserProvider();
	const editorData = useUserEditorProvider();

	useEffect(() => editorData.updateValues(emptyUserEditorFields), [dataHandle]);

	return useMemo(
		() => (
			<CoverBackground color={editorData.color ?? data.color}>
				<Box
					mt={{ base: 'none', hashup: '20px' }}
					w="100%"
					maxW={containerMaxWXl}
					px={{ base: '16px', hashup: '32px', xl: '0' }}
					pb="20px"
				>
					<UserHeader
						isOwner={dataHandle.toLowerCase() === account}
						id={dataHandle ?? ethers.constants.AddressZero}
					/>
					<Editor />
				</Box>
			</CoverBackground>
		),
		[isLoading, account, editorData.color]
	);
};
